module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/reservation@3x-ee70c10d48aaee364f52d70a2d0c048c.webp";